<script>
import axios from 'axios';

export default class ModeloPropostaRepository {
  async getModelosQuery(token, query = '') {
    const baseURL = `${process.env.VUE_APP_API_URL}modelos-proposta?query=${query}`;
    const headers = {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    try {
      const response = await axios.get(baseURL, { headers });
      return response;
    } catch (error) {
      this._handleError(error);
    }
  }

  async createModelo(token, data) {
    const baseURL = `${process.env.VUE_APP_API_URL}modelo-proposta`;
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    try {
      const response = await axios.post(baseURL, data, { headers });
      return response;
    } catch (error) {
       this._handleError(error);
    }
  }

  async getModeloById(token, id) {
    const baseURL = `${process.env.VUE_APP_API_URL}modelo-proposta/${id}`;
    const headers = {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    try {
      const response = await axios.get(baseURL, { headers });
      return response;
    } catch (error) {
       this._handleError(error);
    }
  }

  async editModelo(token, id, data) {
    const baseURL = `${process.env.VUE_APP_API_URL}modelo-proposta/${id}`;
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    try {
      const response = await axios.put(baseURL, data, { headers });
      return response;
    } catch (error) {
       this._handleError(error);
    }
  }

  async deleteModelo(token, id) {
    const baseURL = `${process.env.VUE_APP_API_URL}modelo-proposta/${id}`;
    const headers = {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    try {
      const response = await axios.delete(baseURL, { headers });
      return response;
    } catch (error) {
       this._handleError(error);
    }
  }

  async toggleStatus(token, id, status) {
    const baseURL = `${process.env.VUE_APP_API_URL}modelo-proposta/${id}`;
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    try {
      const response = await axios.put(baseURL, { ativo: status }, { headers });
      return response;
    } catch (error) {
       this._handleError(error);
    }
  }

  async previewModelo(token, data) {
    const baseURL = `${process.env.VUE_APP_API_URL}modelo-proposta/preview`;
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    try {
      const response = await axios.post(baseURL, data, { headers });
      return response;
    } catch (error) {
       if (error.response && error.response.status === 422) {
          return error.response; // ValidationError handle map
       }
       this._handleError(error);
    }
  }

  _handleError(error) {
    console.error("Repository Error:", error);
    throw error;
  }
}
</script>
